import { render, staticRenderFns } from "./Requisition.vue?vue&type=template&id=8b9cd4ba&scoped=true&"
import script from "./Requisition.vue?vue&type=script&lang=js&"
export * from "./Requisition.vue?vue&type=script&lang=js&"
import style0 from "./Requisition.vue?vue&type=style&index=0&id=8b9cd4ba&lang=stylus&scoped=true&"
import style1 from "./Requisition.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9cd4ba",
  null
  
)

export default component.exports